import { render } from "./AddNewAssigneeDialog.vue?vue&type=template&id=7ea4bcc6&scoped=true"
import script from "./AddNewAssigneeDialog.vue?vue&type=script&lang=js"
export * from "./AddNewAssigneeDialog.vue?vue&type=script&lang=js"

import "./AddNewAssigneeDialog.vue?vue&type=style&index=0&id=7ea4bcc6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea4bcc6"]])

export default __exports__